module.exports = __webpack_public_path__ + "static/media/heaven-on-earth.a3373bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/heaven-on-earth.jpg
// module id = 297
// module chunks = 0